module.exports = __webpack_public_path__ + "assets/img/32_643_big.63764d42.jpg";